import loadable from "@loadable/component";
import LinearProgress from "@material-ui/core/LinearProgress";

/**
 * Dynamically loaded version of `SystemSettingsPage`.
 */
const LoadablePage = loadable(
  () => import(/* webpackChunkName: "SystemSettings" */ "."),
  {
    fallback: <LinearProgress />,
  }
);

export default LoadablePage;
